import Vue from "vue"

export default {
  SET_OBJECT(state, { path, value }) {
    Vue.set(state, path, value)
  },
}
